import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { HeadingDisplay } from '@warrenbrasil/nebraska-web';
import { TextDisplay } from '../TextDisplay';
import { InstrumentAvatarFallback } from '@/modules/trade/components/InstrumentAvatarFallback';

import { CustomOperation } from '@/modules/trade/services/custom-operations';
import { getInstrumentSymbolPreffix } from '@/modules/trade/helpers/instruments';
import { TooltipTypes } from '../../types';

interface Props {
  customOperationData: CustomOperation;
}
interface Emits {
  (e: 'tooltip-click', type: TooltipTypes): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  props: {
    customOperationData: null
  },
  emits: ["tooltip-click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'tooltip-click', type: TooltipTypes): void;
}), expose: any, slots: any, attrs: any }) {

const { customOperationData } = __props as {
  customOperationData: CustomOperation;
}





const instrumentSymbolPreffix = computed(() => {
  return getInstrumentSymbolPreffix(customOperationData.instrument.symbol);
});

const handleTooltipClick = (type: TooltipTypes) => {
  emit('tooltip-click', type);
};

return { __sfc: true,emit, instrumentSymbolPreffix, handleTooltipClick, HeadingDisplay, TextDisplay, InstrumentAvatarFallback, TooltipTypes }
}

})